import { Injectable } from '@angular/core';
import { ConfirmationModel, ENDPOINTS, OdataService } from '@evorait/pace-core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OdataConfirmationService {
    public constructor(private readonly odataService: OdataService) {}

    public saveConfirmation(confirmation: ConfirmationModel): Observable<unknown> {
        return this.odataService.deepInsertRequest(
            confirmation,
            ENDPOINTS.NotificationConfirmation,
            confirmation.notificationIdentifier.toString(),
        );
    }
}
